<template>
  <div class="index">
    <div class="index-banner">
      <div class="container index-menu">
        <div class="index-menu-block">
          <p><span>中文数据库</span></p>
          <ul>
            <li>
              <!-- <li> -->
              <a
                href="https://cdc.cnki.net/"
                target="_blank"
                @click="clks"
                class="zwopen"
                >中国知网CHKD</a
              >
            </li>
            <li @click="show('万方医学网')">
              万方医学网
              <!-- <a href="http://med.wanfangdata.com.cn/" target="_blank"
                >万方医学网</a
              > -->
            </li>
            <li @click="show('超星数据库')">
              <!-- <a href="http://www.chaoxing.com/" target="_blank">超星数据库</a> -->
              超星数据库
            </li>
            <!-- <li>
              <a
                href="http://223.93.176.64:8089/login.html?name=book1&pwd=a123456"
                target="_blank"
                >博库中文数据库</a
              >
            </li> -->
          </ul>
        </div>
        <div class="index-menu-block">
          <p><span>外文数据库</span></p>
          <ul>
            <!-- <li>
              <a href="https://www.ncbi.nlm.nih.gov/" target="_blank"
                >全球医学文献资源</a
              >
            </li> -->
            <li>
              <a
                href="http://www.meddata.com.cn?loginName=shjk&password=shjk2019#"
                target="_blank"
                >全球医学文献资源</a
              >
            </li>
            <li @click="SpringerVisible = true">
              Springer数据库
              <!-- <a href="https://www.springer.com/gp" target="_blank"
                >Springer数据库</a
              > -->
            </li>
            <!-- <li>
              <a href="http://139.196.46.250/url/shcdc2_ebscohost.html" target="_blank"
                >GIDEON数据库</a
              >
            </li> -->
            <li @click="show('GIDEON数据库')">
              GIDEON数据库
            </li>

            <!-- <li>
              <a
                href="http://www.meddata.com.cn/ordinary?loginName=book&password=book2019#"
                target="_blank"
                >全球医学文献资源</a
              >
            </li> -->
          </ul>
        </div>
        <div class="index-menu-block">
          <p><span>其他数据库</span></p>
          <ul>
            <li @click="show('读秀中文搜索')">
              读秀中文搜索
              <!-- <a href="http://www.duxiu.com/" target="_blank">读秀中文搜索</a> -->
            </li>
            <li @click="show('生命科学文献服务平台')">
              <!-- <a href="https://wxfw.sinh.ac.cn/" target="_blank"
                >生命科学文献服务平台</a
              > -->
              生命科学文献服务平台
            </li>
            <!-- <li>
              <a
                href="http://ovidsp.ovid.com/ovidweb.cgi?T=JS&amp;CSC=Y&amp;NEWS=n&amp;PAGE=main&amp;D=vbpp18"
                target="_blank"
                >Visible Body</a
              >
            </li>
            <li>
              <a href="http://qbs.hznet.com.cn/bbs/wp_new.html" target="_blank"
                >维普中文期刊数据库</a
              >
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="index-content container">
      <div class="index-content-top">
        <div class="index-block block-one">
          <p class="index-block-title">
            <span class="title-icon book"></span>
            <span class="title-name">期刊收录统计</span>
            <span class="title-eng">Journal Collection Statistics</span>
          </p>
          <ul class="index-block-content">
            <li
              v-for="(item, index) in list"
              :key="index"
              @click="changeInclude(item.name)"
            >
              <p>
                <img :src="item.pic" alt="" />
              </p>
              <i>{{ item.value }}</i>
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <div class="index-block block-two">
          <p class="index-block-title">
            <span class="title-icon collete"></span>
            <span class="title-name">新冠肺炎</span>
            <span class="title-eng">COVID-19 NEWS</span>
            <span class="title-more" @click="getMore">More</span>
          </p>
          <ul class="index-block1-content">
            <li class="clearfix" v-for="(item, index) in newsList" :key="index">
              <p @click="check(item)">{{ item.titleCN }}</p>
              <span>{{ item.updateTime }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="index-block block-three">
        <p class="index-block-title">
          <span class="title-icon done"></span>
          <span class="title-name">成果中科院分区</span>
          <span class="title-eng">CAS Division</span>
        </p>
        <ul class="index-block2-content">
          <li>
            <div id="main" style="width: 420px; height: 257px"></div>
          </li>
          <li>
            <ul class="content-legend">
              <li class="title">
                <p></p>
                <span>2021年</span>
                <span>2020年</span>
                <span>2019年</span>
                <span>2018年</span>
                <span>2017年</span>
              </li>
              <li v-for="(item, value, index) in gainList" :key="index">
                <p>中科院{{ index + 1 }}区</p>
                <span>{{ item.dateCountFive }}</span>
                <span>{{ item.dateCountFour }}</span>
                <span>{{ item.dateCountThree }}</span>
                <span>{{ item.dateCountTwo }}</span>
                <span>{{ item.dateCountOne }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- 点击数据库的弹框 -->
    <el-dialog
      :title="block.name"
      :visible.sync="dialogVisible"
      width="40%"
      top="40vh"
    >
      <div class="data-block">
        <div class="data-block-logo">
          <img :src="block.logo" alt="" />
        </div>
        <div class="data-block-content">
          <p class="content-desp">{{ block.desp }}</p>
          <div class="content-account">
            <div class="account-name">
              <p>账号</p>
              <span>{{ block.account }}</span>
              <button @click="copyJSON(block.account)">复制</button>
            </div>
            <div class="account-name">
              <p>密码</p>
              <span>{{ block.password }}</span>
              <button @click="copyJSON(block.password)">复制</button>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="color: #fff; background-color: #bf232c; border: none"
          @click="goLink(block.url)"
          >前 往</el-button
        >
      </span>
    </el-dialog>

    <!-- 点击springer数据库的弹框 -->
    <el-dialog
      title="Springer"
      :visible.sync="SpringerVisible"
      width="46%"
      top="20vh"
    >
      <div class="data-block" style="align-items: flex-start">
        <div class="data-block-logo">
          <img src="../assets/images/index/spr.png" alt="" />
        </div>
        <div class="data-block-content">
          <p class="content-desp" style="margin-bottom: 8px">
            所有包含的期刊内容均从1997年到最新一期，图书均为2005年之后的出版的内容，包括最新出版的图书，数据库实时更新，完全无延迟，不限制登录并发用户数。中心内用户通过IP地址认证，无需用户名密码。本中心订购了两个数据库分别为Springer
            for Biotechnology数据库和Springer for Health &
            Hospitals数据库。具体使用方法可以参考以下录像和图片指导
          </p>
          <p class="content-red">
            （如果看到有光盘内容，可以到extras.springer.com下载，光盘可能需要装一个虚拟光驱才可以读取。）
          </p>
          <div class="content-links">
            <a
              href="http://v.youku.com/v_show/id_XNTYzODE0OTM2.html?f=19330513"
              target="_bank"
              style="margin-right: 54px"
              >数据库使用演示录像</a
            >
            <a
              href="http://shcdc.cn/res/springer1.png"
              target="_bank"
              style="margin-right: 54px"
              >图示一</a
            >
            <a href="http://shcdc.cn/res/springer2.png" target="_bank"
              >图示二</a
            >
          </div>

          <div class="content-links">
            <a href="http://rd.springer.com/" target="_bank">总库入口</a>
          </div>
          <div class="content-links">
            <a href="http://rd.springer.com/industry/biotech" target="_bank"
              >Springer for Biotechnology数据库入口</a
            >
          </div>
          <div class="content-links">
            <a href="http://rd.springer.com/industry/health" target="_bank"
              >Springer for Health &amp; Hospitals数据库入口</a
            >
          </div>
          <div class="content-links">
            <a href="http://b.eqxiu.com/s/8o263Keo" target="_bank"
              >Springer数据库使用指南微信版</a
            >
          </div>
          <div class="content-links">
            <a href="http://shcdc.cn/url/help.pdf"
              >如何在手机等移动设备中阅读spring电子书</a
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="color: #fff; background-color: #bf232c; border: none"
          @click="SpringerVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HighCharts from "highcharts";
import wordcloud from "highcharts/modules/wordcloud";
import picno from "../assets/images/index/no.png";
import pic1 from "../assets/images/index/4.png";
import pic2 from "../assets/images/index/3.png";
import pic3 from "../assets/images/index/5.png";
import pic4 from "../assets/images/index/1.png";
import pic5 from "../assets/images/index/9.png";
import pic6 from "../assets/images/index/2.png";
import pic7 from "../assets/images/index/10.jpg";
import duxiu from "../assets/images/index/duxiu.png";
import wanfang from "../assets/images/index/wanfang.png";
import zhiwang from "../assets/images/index/zhiwang.png";
import chaoxing from "../assets/images/index/chaoxing.png";
import ebscoconnectlogo from "../assets/images/index/ebscoconnectlogo.png";

wordcloud(HighCharts);
require("highcharts/modules/exporting")(HighCharts);
export default {
  data() {
    return {
      newsList: [],
      dialogVisible: false,
      SpringerVisible: false,
      gainList: [],
      block: {},
      linkList: [
        {
          name: "读秀中文搜索",
          logo: duxiu,
          url: "http://www.duxiu.com/",
          desp:
            "读秀 知识库是由海量图书等文献资源组成的庞大的知识系统,是一个可以对文献资源及其全文内容进行深度检索,并且提供原文传送服务的平台。",
          account: "scdc",
          password: "fa7f20e1@!",
        },
        {
          name: "万方医学网",
          logo: wanfang,
          url: "https://www.wanfangdata.com.cn/index.html",
          desp:
            "在本平台检索到的文献下面有“下载”“在线阅读”连接按钮的，都是万方数据收录的文献，可以直接下载查看，如果没有该链接的会标示出来该文献的收录平台，请到文献所属平台下载。",
          account: "shcdc",
          password: "shcdc",
        },
        {
          name: "中国知网CHKD",
          logo: zhiwang,
          // url:
          //   " https://epub.cnki.net/kns/logindigital.aspx?ParentLocation=http://cdc.cnki.net",
          url: "http://192.168.1.73:8290/static/zhiwang.html",
          desp:
            "《公共卫生知识服务平台》是基于“公共卫生知识资源总库”构建的一个专业化知识服务平台，借助互联网或本地镜像网站，以信息推送和检索方式，面向公共卫生系统各机构提供集资源整合、知识检索、信息推送、数据分析和内容管理为一体的个性化知识服务。",
          account: "scdc2017",
          password: "scdc2017",
        },
        {
          name: "超星数据库",
          logo: chaoxing,
          url: "http://login.zhizhen.com/",
          desp:
            "超星发现系统以数十亿海量元数据为基础，利用数据仓储,资源整合，知识挖掘，数据分析，文献计量学模型等相关技术通过分面聚类，引文分析，知识关联分析等实现高价值学术文献发现，纵横结合的深度知识挖掘，可视化的全方位知识关联",
          account: "scdc",
          password: "fa7f20e1@!",
        },
        {
          name: "生命科学文献服务平台",
          logo: pic7,
          url: "https://wxfw.sinh.ac.cn/",
          desp:
            "生命科学文献服务平台联合国内图书情报界专家专门定制研发了一款适合我馆使用的外文文献检索与传递服务系统。",
          account: "w636",
          password: "Asd_**1234",
        },
        {
          name: "GIDEON数据库",
          logo: ebscoconnectlogo,
          url: "https://search.ebscohost.com/",
          desp:
            "GIDEON全球传染病与流行病在线诊断参考资源是由GIDEON Informatics Inc.公司独家开发的传染病学信息系统，除了有网络平台诊断接口，也包括了针对传染病的治疗、热带传染病、流行病学以及微生物学等信息，以及实时的全球性传染病散布状况。在内容上，它包含了360多种疾病、235个国家、2,070种微生物与330多种抗菌药物与80多种疫苗的介绍。另外，21,000余笔的注记描述了在各个国家的传染病状况，还有超过35,000张的照片、图表、电子图与附录。内容来源针对MEDLINE每季所发表的研究，世界卫生组织的定期发表，重要的各大国际会议、使用者反应以及其他相关内容做最实时的更新，严格遵循循证医学的标准。",
          account: "ns014009",
          password: "SMunicipal@2024",
        },
      ],
      list: [
        {
          name: "北大核心",
          pic: pic6,
          value: "",
        },
        {
          name: "Medline",
          pic: pic1,
          value: "",
        },
        {
          name: "CSCD",
          pic: pic2,
          value: "",
        },
        {
          name: "SCIE",
          pic: pic3,
          value: "",
        },
        {
          name: "CSTPCD",
          pic: pic4,
          value: "",
        },
        {
          name: "CA",
          pic: picno,
          value: "",
        },
        {
          name: "CBST",
          pic: picno,
          value: "",
        },
        {
          name: "F1000",
          pic: pic5,
          value: "",
        },
        {
          name: "OA",
          pic: picno,
          value: "",
        },
        {
          name: "AJ",
          pic: picno,
          value: "",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getSearchAllInfo();
    this.getGain();
    this.getAllResult();
  },
  methods: {
    clks() {
      var zwopen = document.querySelector(".zwopen");
      if (zwopen.href == "https://cdc.cnki.net/") {
        event.preventDefault();
        var page = window.open();
        page.location.href =
          "https://login.cnki.net/TopLoginNew/api/loginapi/Login?callback=jQuery111308717373138228544_1630633458387&userName=scdc2017&pwd=scdc2017&isAutoLogin=true&p=2&vc=%7C0&_=1630633458389";
        setTimeout(function() {
          page.location.href = "https://cdc.cnki.net/";
        }, 700);
      }
    },
    // 查看详情
    check(item) {
      this.$router.push({
        name: "Detail",
        params: {
          abstractCN: item.abstractCN,
          link: item.link,
        },
      });
    },
    // 获取新冠肺炎
    getSearchAllInfo() {
      let that = this;
      this.$axios({
        method: "get",
        url: "/api/covidFind?key=COVID-19&size=4",
      })
        .then(function(res) {
          that.newsList = res.data.data.slice(0, 4);
        })
        .catch(function(thrown) {});
    },
    // 获取期刊
    getAllResult() {
      let that = this;
      this.$axios({
        method: "get",
        url: "/api/retrieval",
      }).then((res) => {
        let list = res.data.data.includeInfos;
        list.forEach((item) => {
          that.list.forEach((value) => {
            if (item.code == value.name) {
              value.value = item.includeNum;
            }
          });
        });
      });
    },
    // 获取更多
    getMore() {
      this.$router.push({
        name: "newList",
      });
    },
    rTime(date) {
      let json_date = new Date(date).toJSON();
      return new Date(+new Date(json_date) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    changeInclude(val) {
      this.$router.push({
        name: "Results",
        params: {
          name: val,
        },
      });
    },
    show(name) {
      this.linkList.forEach((item) => {
        if (item.name == name) {
          this.block = item;
        }
      });
      this.dialogVisible = true;
    },
    goLink(url) {
      window.open(url, "_blank");
    },
    // 实现复制
    async copyJSON(item) {
      let oInput = document.createElement("input"); //创建input节点
      oInput.value = item; //给input的value赋值
      document.body.appendChild(oInput); //向页面插入input节点
      oInput.select(); // 选中input
      try {
        await document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          type: "success",
          message: "复制成功",
        });
      } catch (e) {
        this.$message({
          type: "success",
          message: "复制失败",
        });
      }
    },
    // 获取中科院成果
    getGain() {
      let that = this;
      this.$axios({
        method: "get",
        url: "/api/queryZkyResult",
      }).then((res) => {
        that.gainList = res.data;
        console.log("g", that.gainList);
        var chart = HighCharts.chart("main", {
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0,
            },
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
          },
          credits: {
            enabled: false,
          },
          exporting: {
            enabled: false,
          },
          title: {
            text: null,
          },
          tooltip: {
            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              depth: 35,
              dataLabels: {
                enabled: true,
                format: "{point.name}",
              },
            },
          },
          series: [
            {
              name: "成果所占比例",
              type: "pie",
              radius: "50%",
              data: [
                { y: res.data.oneAreaList.count, name: "中科院1区" },
                { y: res.data.twoAreaList.count, name: "中科院2区" },
                { y: res.data.threeAreaList.count, name: "中科院3区" },
                {
                  y: res.data.fourAreaList.count,
                  name: "中科院4区",
                  sliced: true,
                  selected: true,
                },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  .index-banner {
    width: 100%;
    height: 320px;
    background: url("../assets/images/index/center-back.png") 100% no-repeat;
    background-size: 100% 100%;
    border-top: 1px solid transparent;
  }
  .index-menu {
    margin-top: 55px;
    display: flex;
    justify-content: space-around;
    .index-menu-block {
      width: 320px;
      height: 222px;
      padding: 23px 32px 0 27px;
      box-sizing: border-box;
      background: #ffffff;
      opacity: 0.9;
      border-radius: 4px;
      p {
        border-bottom: 1px solid #c0232b;
        color: #ffffff;
        margin-bottom: 28px;
        span {
          display: inline-block;
          padding: 4px 5px;
          background-color: #c0232b;
        }
      }
      ul {
        padding-left: 26px;
        li {
          list-style: disc;
          margin-bottom: 12px;
          color: #000;
          cursor: pointer;
          a {
            margin-bottom: 12px;
            color: #000;
            cursor: pointer;
          }
        }
        li:hover {
          color: #c0232b;
          a {
            color: #c0232b;
          }
        }
      }
    }
  }
  .index-content {
    padding: 40px 23px 82px 29px;
    box-sizing: border-box;
    .index-content-top {
      display: flex;
      //   justify-content: space-around;
      margin-bottom: 40px;
    }

    .index-block {
      text-align: left;
      width: 533px;
      .index-block-title {
        display: flex;
        align-items: center;
        padding-left: 9px;
        padding-bottom: 11px;
        border-bottom: 1px solid #eeeeee;
        .title-name {
          margin-left: 9px;
          margin-right: 6px;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
        }
        .title-eng {
          font-size: 12px;
          font-weight: 600;
          color: #cccccc;
        }
        .title-more {
          color: #bf232c;
          font-size: 12px;
          margin-left: auto;
          cursor: pointer;
        }
      }
      .book {
        width: 14px;
        height: 16px;
        background: url(../assets/images/index/book.png) 100% no-repeat;
      }
      .collete {
        width: 15px;
        height: 16px;
        background: url(../assets/images/index/collete.png) 100% no-repeat;
      }
      .done {
        width: 14px;
        height: 14px;
        background: url(../assets/images/index/done.png) 100% no-repeat;
      }
      .index-block-content {
        display: flex;
        flex-flow: row wrap;
        li {
          width: 79px;
          text-align: center;
          margin-top: 26px;
          margin-right: 34px;
          cursor: pointer;
          p {
            width: 100%;
            height: 39px;
            margin-bottom: 6px;
            line-height: 39px;
            img {
              width: 100%;
              // height: 100%;
              vertical-align: middle;
            }
          }
          p:hover {
            img {
              transform: scale(1.1);
            }
          }
          span {
            color: #c0232b;
          }
          i {
            font-style: normal;
            display: block;
            font-size: 12px;
            color: #333;
            margin-bottom: 4px;
          }
        }
        li:nth-child(5n) {
          margin-right: 0;
        }
      }
      .index-block1-content {
        padding-top: 9px;
        padding-left: 4px;
        li {
          margin-top: 12px;
        }
        p {
          color: #333333;
          margin-bottom: 6px;
          cursor: pointer;
        }
        p:hover {
          color: #c0232b;
        }
        span {
          color: #aaaaaa;
          font-size: 12px;
          // float: right;
        }
      }
    }
    .block-two {
      margin-left: auto;
    }
    .block-three {
      width: 100%;
      box-sizing: border-box;
    }
    .index-block2-content {
      display: flex;
      .content-legend {
        margin-left: 150px;
        min-width: 590px;
        height: 100%;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            color: #333333;
            font-weight: bold;
            // margin-right: 31px;
            width: 20%;
          }
          span {
            font-size: 14px;
            color: #c0232b;
            width: 20%;
            text-align: center;
          }
        }
        .title {
          p {
            width: 20%;
          }
          span {
            color: #333333;
            font-weight: bold;
            font-size: 14px;
            width: 20%;
          }
        }
      }
    }
  }
  .data-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;

    .data-block-logo {
      flex-shrink: 0;
      width: 210px;
      height: 84px;
      margin-right: 50px;
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }
    .data-block-content {
      .content-desp {
        color: #333;
        margin-bottom: 30px;
      }
      .content-red {
        color: #c0232b;
        letter-spacing: 0.5px;
      }
      .content-links {
        margin: 12px 0;
        a {
          color: #035bad;
          text-decoration: underline;
        }
      }
      .content-account {
        display: flex;
        .account-name {
          display: flex;
          margin-right: 30px;
          p {
            margin-right: 7px;
          }
          span {
            color: #ffa133;
            margin-right: 13px;
          }
          button {
            background-color: #4ace10;
            color: #fff;
            border: none;
            width: 36px;
            height: 20px;
            cursor: pointer;
            outline: none; //消除默认点击蓝色边框效果
          }
          button:active {
            transform: scale(1.1);
          }
        }
      }
    }
  }
  /deep/.el-dialog__title {
    color: #333333;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue